import axios from 'axios'

const state = {
  jobs: []
}

const mutations = {
  UPDATE_JOBS (state, payload) {
    state.jobs = payload
  }
}

const actions = {
  getJobs ({ commit }) {
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/scheduling/')
      .then((response) => {
        commit('UPDATE_JOBS', response.data)
      })
  }
}

const getters = {
  jobs: state => state.jobs
}

const schedulingModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default schedulingModule
